import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import { CONSTANT } from '../../utils/constant';
import Label from './common/label';

const SalesManager = ({ labels, errors, touched, role }) => {
  const {
    KEYS: {
      ROLES: { SALES_REP }
    }
  } = CONSTANT;

  const getFieldLabel = () =>
    role === SALES_REP ? labels.SALE_MANAGER : labels.MANAGER;
  return (
    <>
      <Label labelName={getFieldLabel()} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.salesManager && touched.salesManager ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_MANAGER}
          name="salesManager"
          className="select-style"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.salesManager}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

SalesManager.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
};

export default SalesManager;
